<template>
  <div>
    <div class="page-header">
      <div class="pageTitle">
        <div class="pageName">{{ "Storm Control" }}</div>
      </div>
    </div>
    <div class="row">
      <p style="margin: 20px 15px 10px">
        {{ "This page shows the current Storm Control and related configuration." }}
      </p>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <block-cntr :btitle="'Storm Control Config'" style="height: 410px">
          <div class="form-inline">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="clkEdit()"
                  class="btn"
                  :class="{ disabled: false }"
                  style="padding: 0px"
                >
                  <i class="fa fa-edit page-tableaction"></i>
                </div>
              </div>
            </span>
          </div>
          <!--风暴控制列表-->
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th width="40px">
                  <input
                    type="checkbox"
                    v-model="isSelectAll"
                    @change="changeSelectAll()"
                    id="idSelectAllPort"
                  />
                  <label for="idSelectAllPort"></label>
                </th>
                <th
                  v-for="(value, key) in stormControlTable.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 350px">
              <tr
                v-for="(row, index) in stormControlTable.data"
                :key="row.port"
                :class="{ 'true:': true }"
              >
                <td width="40px">
                  <div v-if="!row.isNew">
                    <input
                      type="checkbox"
                      v-model="row.selected"
                      :id="'idRowSelectAlarm' + index"
                    />
                    <label :for="'idRowSelectAlarm' + index"></label>
                  </div>
                </td>
                <td>
                  <div>{{ row.port }}</div>
                </td>
                <td>
                  <div>{{ row.bcastRate }}</div>
                </td>
                <td>
                  <div>{{ row.mcastRate == "0" ? "disabled" : row.mcastRate }}</div>
                </td>
                <td>
                  <div>{{ row.ucastRate == "0" ? "disabled" : row.ucastRate }}</div>
                </td>
              </tr>
            </tbody>
          </table>

          <!--RateEnable 和 Rate配置-->
          <div v-if="isShowConfigTable">
            <dialog-box
              :btitle="'Storm Control Config Edit'"
              @close="isShowConfigTable = false"
              style="min-height: 410px"
            >
              <form class="form-horizontal" role="form">
                <!--bcastRateEnable -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="bcastRateEnable"
                    >Bcast Rate Enable</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="bcastRateEnable"
                      @change="changeBcastRateEnable()"
                      v-model="stormControlForm.bcastRateEnable"
                    >
                      <option label="enable" value="1"></option>
                      <!-- disable : reset to max value 32000000pps -->
                      <option label="disable" value="0"></option>
                    </select>
                  </div>
                </div>

                <!--bcastRate -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="bcastRate"
                    >Bcast Rate (pps) </label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'bcastRate',
                        stormControlForm.bcastRate
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="bcastRate"
                      v-model="stormControlForm.bcastRate"
                      placeholder="INTEGER<64-32000000>(pps)"
                      :disabled="stormControlForm.bcastRateEnable == '0'"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'bcastRate',
                          stormControlForm.bcastRate
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("bcastRate", stormControlForm.bcastRate)
                      }}
                    </small>
                  </div>
                </div>

                <!--mcastRateEnable -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="mcastRateEnable"
                    >Mcast Rate Enable</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="mcastRateEnable"
                      @change="changeMcastRateEnable()"
                      v-model="stormControlForm.mcastRateEnable"
                    >
                      <option label="enable" value="1"></option>
                      <option label="disable" value="0"></option>
                    </select>
                  </div>
                </div>

                <!--mcastRate -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="mcastRate"
                    >Mcast Rate (pps) </label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'mcastRate',
                        stormControlForm.mcastRate
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="mcastRate"
                      v-model="stormControlForm.mcastRate"
                      placeholder="INTEGER<64-32000000>(pps)"
                      :disabled="stormControlForm.mcastRateEnable == '0'"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'mcastRate',
                          stormControlForm.mcastRate
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("mcastRate", stormControlForm.mcastRate)
                      }}
                    </small>
                  </div>
                </div>

                <!--ucastRateEnable -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ucastRateEnable"
                    >Ucast Rate Enable</label
                  >
                  <div class="col-sm-5">
                    <select
                      type="text"
                      class="form-control"
                      id="ucastRateEnable"
                      @change="changeUcastRateEnable()"
                      v-model="stormControlForm.ucastRateEnable"
                    >
                      <option label="enable" value="1"></option>
                      <option label="disable" value="0"></option>
                    </select>
                  </div>
                </div>

                <!--ucastRate -->
                <div class="form-group">
                  <label class="col-sm-3 control-label" for="ucastRate"
                    >Ucast Rate (pps) </label
                  >
                  <div
                    class="col-sm-5"
                    :class="{
                      'has-error': checkParameters(
                        'UcastRate',
                        stormControlForm.ucastRate
                      ),
                    }"
                  >
                    <input
                      type="text"
                      class="form-control"
                      id="ucastRate"
                      v-model="stormControlForm.ucastRate"
                      placeholder="INTEGER<64-32000000>(pps)"
                      :disabled="stormControlForm.ucastRateEnable == '0'"
                      autocomplete="off"
                    />
                    <small
                      class="help-block"
                      :style="{
                        display: checkParameters(
                          'ucastRate',
                          stormControlForm.ucastRate
                        )
                          ? 'block'
                          : 'none',
                      }"
                      >{{
                        checkParameters("ucastRate", stormControlForm.ucastRate)
                      }}
                    </small>
                  </div>
                </div>
                
                <button
                  type="button"
                  class="btn btn-primary"
                  style="
                    margin-left: 20%;
                    min-width: 77px;
                    color: #fff;
                    background-color: #008b8b;
                    border-color: #008080;
                  "
                  @click="clkApply()"
                >
                  {{ "Apply" }}
                </button>
                <span style="margin-left: 10px">
                  <button
                    type="button"
                    class="btn btn-default"
                    style="min-width: 77px"
                    @click="clkCancel()"
                  >
                    {{ "Cancel" }}
                  </button>
                </span>
              </form>
            </dialog-box>
          </div>
        </block-cntr>
      </div>
    </div>

    <info-box :ibox="iBox"></info-box>
  </div>
</template>

<script>
import en from "./../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "stormControl",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  data() {
    return {
      page: en.page.igmpconfig,
      isShowConfigTable: false,
      isEditClik: false,
      isSelectAll: false,
      iBox: {},
      stormControlTable: "",
      stormControlForm: {
        port: "",
        bcastRate: "", 
        mcastRate: "", 
        ucastRate: "", 
        bcastRateEnable: "1", //enable 1, disable 0 不是使能关闭，对于广播类型,不能disable, 而是开启为最大值 
        mcastRateEnable: "0", //disable 0 
        ucastRateEnable: "0", //disable 0
      },
    }
  },
  created() {
    this.loadStormControlTable()
  },
  methods: {
    loadStormControlTable() {
      get("stormControlConfig")
        .then((res) => (this.stormControlTable = res.data))
        .catch((err) => {
          this.stormControlTable = en.stormControlTable
        })
    },
    clkEdit() {
      for (let i = 0; i < this.stormControlTable.data.length; i++) {
        if (this.stormControlTable.data[i].selected) {
          this.stormControlForm.bcastRate = this.stormControlTable.data[i].bcastRate
          /* bcastRate是最大值32000000时 bcastRateEnable显示"0" -- disable */
          if (this.stormControlTable.data[i].bcastRate == 32000000) {
            this.stormControlForm.bcastRateEnable = "0"  
          } else {
            this.stormControlForm.bcastRateEnable = "1"
          }

          if(this.stormControlTable.data[i].mcastRate == "0") {
            this.stormControlForm.mcastRateEnable = "0"
            this.stormControlForm.mcastRate = ""
          } else {
            this.stormControlForm.mcastRateEnable = "1"
            this.stormControlForm.mcastRate = this.stormControlTable.data[i].mcastRate
          }

          if(this.stormControlTable.data[i].ucastRate == "0") {
            this.stormControlForm.ucastRateEnable = "0"
            this.stormControlForm.ucastRate = ""
          } else {
            this.stormControlForm.ucastRateEnable = "1"
            this.stormControlForm.ucastRate = this.stormControlTable.data[i].ucastRate
          }

          this.isShowConfigTable = true
          this.isEditClik = true
          return
        }
      }
    },
    clkCancel() {
      this.isShowConfigTable = false
      console.log(this.isShowConfigTable)
    },
    changeSelectAll() {
      for (let i = 0; i < this.stormControlTable.data.length; i++) {
        if (this.isSelectAll) {
          this.stormControlTable.data[i].selected = true
        } else {
          this.stormControlTable.data[i].selected = false
        }
      }
    },
    selectNull() {
      for (let i = 0; i < this.stormControlTable.data.length; i++) {
        this.stormControlTable.data[i].selected = false
      }
      this.isSelectAll = false
    },

    clkApply() {
      var list = []
      var stormControl = {
        bcastRate: Number(this.stormControlForm.bcastRate),
        mcastRate: Number(this.stormControlForm.mcastRate),
        ucastRate: Number(this.stormControlForm.ucastRate),
        portList: [],
      }

      if(this.stormControlForm.bcastRate == "") {
          this.showAlertBox("warn", "Message", "Invalid bcastRate")
          return
      }

      if (this.checkParameters("bcastRate", this.stormControlForm.bcastRate)) {
          this.showAlertBox("warn", "Message", "Invalid bcastRate")
          return
      }

      if (this.stormControlForm.mcastRateEnable == "0") {
        stormControl.mcastRate = Number(0)
      } else {
        if (this.stormControlForm.mcastRate == "" || this.checkParameters("mcastRate", this.stormControlForm.mcastRate)) {
          this.showAlertBox("warn", "Message", "Invalid mcastRate")
          return
        }
      }

      if (this.stormControlForm.ucastRateEnable == "0") {
        stormControl.ucastRate = Number(0)
      } else {
        if (this.stormControlForm.ucastRate == "" || this.checkParameters("ucastRate", this.stormControlForm.ucastRate)) {
          this.showAlertBox("warn", "Message", "Invalid ucastRate")
          return
        }
      }

      for (let i = 0; i < this.stormControlTable.data.length; i++) {
        if (this.stormControlTable.data[i].selected) {
          list.push({ port: this.stormControlTable.data[i].port })
        }
      }
      stormControl["portList"] = list

      post("stormControlConfig", stormControl)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadStormControlTable()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else {
            this.showAlertBox("warn", "Message", res.data.msg)
          }
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowConfigTable = false
      this.selectNull()
    },

    changeBcastRateEnable() {
      /*对于广播类型,不能disable, 而是enable,且开启为最大值*/
      if (this.stormControlForm.bcastRateEnable == "0") {
        this.stormControlForm.bcastRate = "32000000"
      } 
    },

    changeMcastRateEnable() {
      if (this.stormControlForm.mcastRateEnable == "0") {
        this.stormControlForm.mcastRate = ""
      }
    },

    changeUcastRateEnable() {
      if (this.stormControlForm.ucastRateEnable == "0") {
        this.stormControlForm.ucastRate = ""
      }
    },

    checkParameters(type, value) {
      if (value === "") {
        return null
      }
      if (type == "bcastRate") {
        if (isNaN(Number(value)) || Number(value) < 64 || Number(value) > 32000000) {
          return "broadcast Target rate must be in range 64-32000000"
        }
      } else if (type == "mcastRate") {
        if (isNaN(Number(value)) || Number(value) < 64 || Number(value) > 32000000) {
          return "multicast Target rate must be in range 64-32000000"
        }
      }else if (type == "ucastRate") {
        if (isNaN(Number(value)) || Number(value) < 64 || Number(value) > 32000000) {
          return "unicast Target rate must be in range 64-32000000"
        }
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>